<template>
  <div>
    <b-row>
      <b-col cols="12">
        <ListInstallations />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import ListInstallations from '@/views/installations/ListTable'

export default {
  components: {
    BRow,
    BCol,
    ListInstallations,
  },
}
</script>
